// Schema generators for different types of structured data

export const generateLocalBusinessSchema = () => ({
    "@context": "https://schema.org",
    "@type": "HairSalon",
    "name": "Pasmo The Beauty Lab",
    "image": "https://pasmolab.com/homepage.jpg",
    "@id": "https://pasmolab.com/#organization",
    "url": "https://pasmolab.com/",
    "telephone": "+1-703-123-4567", // TODO: Add actual phone number
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "7121 Leesburg Pike",
        "addressLocality": "Falls Church",
        "addressRegion": "VA",
        "postalCode": "22043",
        "addressCountry": "US"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 38.87105093650631,
        "longitude": -77.1750977886858
    },
    "areaServed": [
        {
            "@type": "City",
            "name": "Falls Church",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "McLean",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Vienna",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Reston",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Tysons Corner",
            "addressRegion": "VA"
        },
        {
            "@type": "AdministrativeArea",
            "name": "Fairfax County",
            "addressRegion": "VA"
        },
        {
            "@type": "AdministrativeArea",
            "name": "Northern Virginia",
            "addressRegion": "VA"
        }
    ],
    "openingHoursSpecification": [
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "10:00",
            "closes": "19:00"
        }
    ],
    "priceRange": "$$",
    "sameAs": [
        "https://instagram.com/annaveret_hair",
        "https://mysite.vagaro.com/beautybymkp/book-now"
    ],
    "makesOffer": [
        {
            "@type": "Offer",
            "itemOffered": {
                "@type": "Service",
                "name": "Balayage",
                "description": "Expert hand-painted highlights and balayage techniques"
            }
        },
        {
            "@type": "Offer",
            "itemOffered": {
                "@type": "Service",
                "name": "Color Correction",
                "description": "Professional color correction services"
            }
        },
        {
            "@type": "Offer",
            "itemOffered": {
                "@type": "Service",
                "name": "Haircuts",
                "description": "Precision haircuts for women, men, and children"
            }
        }
    ],
    "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "127"
    },
    "review": [
        {
            "@type": "Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5"
            },
            "author": {
                "@type": "Person",
                "name": "Sarah T."
            },
            "reviewBody": "Anna is absolutely amazing! She transformed my dark hair into a beautiful blonde balayage. The color looks so natural and she really took the time to understand what I wanted."
        }
    ]
});

export const generateServiceSchema = (service) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.title,
    "provider": {
        "@type": "HairSalon",
        "name": "Pasmo The Beauty Lab",
        "@id": "https://pasmolab.com/#organization"
    },
    "areaServed": [
        {
            "@type": "City",
            "name": "Falls Church",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "McLean",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Vienna",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Reston",
            "addressRegion": "VA"
        },
        {
            "@type": "City",
            "name": "Tysons Corner",
            "addressRegion": "VA"
        },
        {
            "@type": "AdministrativeArea",
            "name": "Fairfax County",
            "addressRegion": "VA"
        },
        {
            "@type": "AdministrativeArea",
            "name": "Northern Virginia",
            "addressRegion": "VA"
        }
    ],
    "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": service.title,
        "itemListElement": [
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": service.title,
                    "description": service.description
                },
                "price": service.price,
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            }
        ]
    }
});

export const generateFAQSchema = () => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
        {
            "@type": "Question",
            "name": "What is balayage and how is it different from traditional highlights?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Balayage is a French hair coloring technique where color is hand-painted onto the hair to create a natural, graduated effect. Unlike traditional foil highlights, balayage creates softer, more natural-looking results with less obvious regrowth lines. The technique allows for more customization and typically requires less maintenance."
            }
        },
        {
            "@type": "Question",
            "name": "How often should I get my balayage touched up?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Balayage typically requires less maintenance than traditional highlights. Most clients return every 12-16 weeks for a touch-up, though this can vary based on your hair growth rate and desired look. The beauty of balayage is that it grows out naturally, so you won't have harsh regrowth lines."
            }
        },
        {
            "@type": "Question",
            "name": "Do you specialize in Asian hair?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! Anna has extensive experience working with Asian hair textures and understands the unique characteristics and challenges. She specializes in achieving natural-looking color results while maintaining hair health, using techniques specifically adapted for Asian hair."
            }
        },
        {
            "@type": "Question",
            "name": "How long does a color correction service take?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Color correction services typically take 4-6 hours, depending on the complexity of the correction needed. We always start with a consultation to assess your hair and discuss realistic expectations. Multiple sessions may be required for dramatic color changes to maintain hair health."
            }
        },
        {
            "@type": "Question",
            "name": "What areas do you serve?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We're located in Falls Church, VA and serve clients from throughout Fairfax County and Northern Virginia, including McLean, Vienna, Reston, Tysons Corner, Arlington, Great Falls, and the greater Washington DC metro area."
            }
        }
    ]
});

export const generateArticleSchema = (article) => ({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.summary,
    "image": article.image || "https://pasmolab.com/homepage.jpg",
    "datePublished": article.date,
    "dateModified": article.modifiedDate || article.date,
    "author": {
        "@type": "Person",
        "name": "Anna Veretynska",
        "@id": "https://pasmolab.com/#anna"
    },
    "publisher": {
        "@type": "Organization",
        "name": "Pasmo The Beauty Lab",
        "logo": {
            "@type": "ImageObject",
            "url": "https://pasmolab.com/logo.png"
        }
    },
    "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `https://pasmolab.com/articles/${article.shortName}`
    }
});

export const generatePersonSchema = () => ({
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": "https://pasmolab.com/#anna",
    "name": "Anna Veretynska",
    "jobTitle": "Master Hair Stylist & Colorist",
    "worksFor": {
        "@type": "HairSalon",
        "name": "Pasmo The Beauty Lab",
        "@id": "https://pasmolab.com/#organization"
    },
    "sameAs": [
        "https://instagram.com/annaveret_hair"
    ],
    "knowsAbout": [
        "Balayage",
        "Hair Coloring",
        "Color Correction",
        "Asian Hair Specialist",
        "Hair Cutting",
        "Hair Styling"
    ]
});

export const generateWebPageSchema = (page) => ({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": page.title,
    "description": page.description,
    "url": page.url,
    "isPartOf": {
        "@type": "WebSite",
        "name": "Pasmo The Beauty Lab",
        "url": "https://pasmolab.com"
    },
    "about": {
        "@type": "HairSalon",
        "name": "Pasmo The Beauty Lab",
        "@id": "https://pasmolab.com/#organization"
    }
});

export const generateSearchActionSchema = () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Pasmo The Beauty Lab",
    "url": "https://pasmolab.com",
    "potentialAction": {
        "@type": "SearchAction",
        "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://pasmolab.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
    }
});
